module.exports = __webpack_public_path__ + "img/finish01.7b0e49a0.jpg";